import React, { useEffect, useRef, useState } from "react";
import inputData from "./../inputData";

const Preview = ({ dataset, additionalGuideline, trailCharacters, randomizeOrder }) => {
  const [symbols, setSymbols] = useState([]);

  const canvas = useRef(null);

  const defaultLetterWidth = 80;
  const canvasWidth = 1110;
  const lineHeight = 109;
  const letterHeight = 100;
  const topLineCompensation = 28;
  const textColor = "#000000";
  const lineColor = "#555555";
  const trailTextColor = "#DDDDDD";

  const setupDefaultStyling = (ctx) => {
    ctx.clearRect(0, 0, canvas.current.width, canvas.current.height);
    ctx.font = `${letterHeight}px Arial`;
    ctx.strokeStyle = lineColor;
    ctx.fillStyle = textColor;
  };

  // Translate once by half a pixel
  useEffect(() => {
    const ctx = canvas.current.getContext("2d");
    ctx.translate(0.5, 0.5);
  }, []);

  // Pull the right symbols from the inputData
  useEffect(() => setSymbols(inputData[dataset].symbols), [dataset]);

  // Reorder symbols when randomizeOrder changes
  useEffect(() => {
    if (randomizeOrder) {
      setSymbols((old) => old.sort(() => 0.5 - Math.random()));
    } else {
      setSymbols((old) => old.sort((a, b) => (a.character > b.character ? 1 : -1)));
    }
  }, [dataset, randomizeOrder]);

  // Redraw when options changes, or
  useEffect(() => {
    const ctx = canvas.current.getContext("2d");
    setupDefaultStyling(ctx);

    // TODO - fix this so that dataset is not an Effect dependency anymore
    const defaultDatasetGuideline = inputData[dataset].guideline;

    for (const [index, symbol] of symbols.entries()) {
      const character = symbol["character"];
      const guideline = symbol["guideline"] || defaultDatasetGuideline;
      const letterWidth = symbol["letterWidth"] || defaultLetterWidth;

      // text
      ctx.fillStyle = textColor;
      ctx.fillText(character, 0, (index + 1) * lineHeight);

      if (trailCharacters) {
        for (const i of [1, 2, 3]) {
          ctx.fillStyle = trailTextColor;
          ctx.fillText(character, i * letterWidth, (index + 1) * lineHeight);
        }
      }

      // top line
      ctx.beginPath();
      ctx.setLineDash([]);
      ctx.moveTo(0, (index + 1) * lineHeight - letterHeight + topLineCompensation);
      ctx.lineTo(canvasWidth, (index + 1) * lineHeight - letterHeight + topLineCompensation);
      ctx.stroke();

      if (additionalGuideline) {
        ctx.beginPath();
        ctx.setLineDash([3, 5]);
        ctx.moveTo(0, (index + 1) * lineHeight - guideline);
        ctx.lineTo(canvasWidth, (index + 1) * lineHeight - guideline);
        ctx.stroke();
      }

      // bottom line
      ctx.beginPath();
      ctx.setLineDash([]);
      ctx.moveTo(0, (index + 1) * lineHeight);
      ctx.lineTo(canvasWidth, (index + 1) * lineHeight);
      ctx.stroke();
    }
  }, [dataset, symbols, additionalGuideline, trailCharacters, randomizeOrder]);

  return (
    <section>
      <canvas ref={canvas} width={canvasWidth} height={inputData[dataset].symbols.length * lineHeight + 10}></canvas>
    </section>
  );
};

export default Preview;
